interface SocketUrlOptions {
  path: string;
  host?: string;
  query?: Record<string, string>;
}

export const getSocketURL = ({
  path,
  host,
  query,
}: SocketUrlOptions): string => {
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  const { hostname, port } = window.location;
  const finalHost = host
    ? host.includes(':')
      ? host
      : `${host}${port ? `:${port}` : ''}`
    : `${hostname}${port ? `:${port}` : ''}`;

  const url = new URL(`${protocol}://${finalHost}/${path.replace(/^\/+/, '')}`);

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      url.searchParams.append(key, value);
    });
  }

  return url.toString();
};